import SoftSelect from 'components/SoftSelect'
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import { useRef } from 'react'
import { FormControl, InputLabel, Select } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

export const DropdownField = ({
  intakeAttribute,
  required,
  options,
  label,
  placeholder,
  onChange = (e) => console.log(e),
  moveToNext,
  autoFocus,
  hiddenLabel,
  optionMatchMethod,
  carrierMatchMethod,
}) => {
  const dropdownRef = useRef()

  const optionsMapping = optionMatchMethod
    ? options
        .filter((option) => option.subType === optionMatchMethod)
        .map(({ value, label }) => ({
          value,
          label,
        }))
    : carrierMatchMethod
    ? options
        .filter((option) => option.provider === carrierMatchMethod)
        .map(({ value, label }) => ({
          value,
          label,
        }))
    : options.map(({ value, label }) => ({
        value,
        label,
      }))

  const handleChange = ({ value }) => {
    onChange(value)
    document.getElementById('onboardingNext')?.focus()
  }
  return (
    <SoftBox
      display="flex"
      flexDirection="column"
      justifyContent="flex-end"
      height="auto"
    >
      <SoftBox
        ml={0.5}
        lineHeight={0}
        display={hiddenLabel ? 'none' : 'inline-block'}
      >
        <SoftTypography
          component="label"
          variant="body2"
          fontWeight="regular"
          textTransform="capitalize"
        >
          {label}
          {required ? <span style={{ color: 'red' }}> *</span> : null}
        </SoftTypography>
      </SoftBox>
      <SoftSelect
        ref={dropdownRef}
        placeholder={placeholder}
        value={
          intakeAttribute != null
            ? {
                value: intakeAttribute,
                label: options.find(({ value }) => intakeAttribute === value)
                  ?.label,
              }
            : null
        }
        defaultValue={{
          value: intakeAttribute,
          label: options.find(({ value }) => intakeAttribute === value)?.label,
        }}
        options={optionsMapping}
        // onChange={({ value }) => onChange(value)}
        onChange={handleChange}
        // onKeyPress={moveToNext}
        autoFocus={autoFocus}
      />
    </SoftBox>
  )
}
